import React from 'react';
import fr from 'facet-rest';

import ManagedAccountDocuments
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/ManagedAccountDocuments/ManagedAccountDocuments';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  FDBox,
  FDContentContainer, FDHeadlineText, FDPaper, FDTitleText,
} from '@facet-wealth/design';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';

export default function ManagedAccountDocumentsPage() {
  const { pageContentResource } = usePageContentContext();
  useBoneBackgroundColor();
  if (!pageContentResource.relationship(fr.relationships.documents.name)) return null;


  return (
    <FDBox paddingY={2}>
      <FDContentContainer maxWidth={'xl'}>
        <FDBox>
          <FDHeadlineText value={pageContentResource.attr('title')} size={'lg'} />
        </FDBox>
        <FDBox paddingY={2}>
          <FDTitleText value={pageContentResource.attr('subtitle')} size={'sm'} />
        </FDBox>
        <FDPaper appearance={'elevated'}>
          <ManagedAccountDocuments baseLink={pageContentResource.relationship(fr.relationships.documents.name).link('related')} showAccountOptions />
        </FDPaper>
      </FDContentContainer>
    </FDBox>
  );
}
